import "./FormContainer.css";

export default function FormContainer({children}) {
    return (
        <div className="form-container fade-in">
            {children}
        </div>
    )
}